export const FEET_IN_METER = 3.28084;
export function metersToFeet(meters: number): number {
  return meters * FEET_IN_METER;
}

export const METERS_IN_MILE = 1609.34;
export function metersToMiles(meters: number): number {
  return meters / METERS_IN_MILE;
}

export const ONE_MILE = 5280;
export function feetToMiles(feet: number): number {
  return feet / 5280;
}
